import moment from 'moment/moment'

import { AppDateFormats, DEFAULT_SYSTEM_FORMAT_DAY_PICKER } from 'Core/constants'

export const getCurrentYear = (): string => {
	return moment().format('YYYY')
}

export const formatDate = (dateFormat: AppDateFormats) => (date: string) =>
	date ? moment(date).format(dateFormat) : null

export const formatDateTime = (dateFormat: AppDateFormats, date: string | null) =>
	date ? moment(date).format(`${dateFormat} HH:mm:ss`) : null

export const getDateDisabled = ({
	date,
	ranges,
	startDate,
	endDate,
	nearFirstRightDate,
	nearFirstLeftDate,
	shouldCheck
}: {
	date: moment.Moment
	ranges: {
		startDate: moment.Moment | null
		endDate: moment.Moment | null
	}[]
	startDate: moment.Moment | null
	endDate: moment.Moment | null
	nearFirstRightDate: moment.Moment | null
	nearFirstLeftDate: moment.Moment | null
	shouldCheck: 'end' | 'start'
}) => {
	if ((startDate && shouldCheck === 'end') || (endDate && shouldCheck === 'start')) {
		return (
			date.isSameOrAfter(nearFirstRightDate, 'day') ||
			date.isSameOrBefore(nearFirstLeftDate, 'day')
		)
	}

	// disable busy ranges for new items
	for (const range of ranges) {
		const startDate = moment(range.startDate, DEFAULT_SYSTEM_FORMAT_DAY_PICKER)
		const endDate = moment(range.endDate, DEFAULT_SYSTEM_FORMAT_DAY_PICKER)
		const isDateBusy =
			date.isSame(startDate, 'day') ||
			date.isSame(endDate, 'day') ||
			(date.isAfter(startDate, 'day') && date.isBefore(endDate, 'day'))
		if (isDateBusy) {
			return true
		}
	}
	return false
}
